import { Input, Table } from "reactstrap";
import { ApolloError} from "@apollo/client";
import { IIndividualLight, ISearchIndividualsForNewResult} from "../../../../types/individual";
import { ChangeEvent, useEffect, useState,useId } from "react";
import React from "react";
import SpinnerOverlay from "../../../common/spinner/spinner";
import OmsToolTip from "../../../common/oms-tooltip/oms-tooltip";

type IndividualListProp = {
    onSelect: (individual: Partial<ISearchIndividualsForNewResult>|undefined)=>void;
    individuals: Partial<ISearchIndividualsForNewResult>[];
    selectedIndividualId: number;
    loading: boolean;
    error: ApolloError | undefined;
}

const IndividualList = (prop:IndividualListProp) =>{
    const {onSelect,individuals,selectedIndividualId,loading,error} = prop;
    const [checkedValues, setCheckedValues] = useState<number[]>([]);

    useEffect(()=>{
        setCheckedValues([]);
        //checkGroup.init(individuals.map((e: IIndividual) => e.individualId))
        //console.log("individuals:",individuals)
        //console.log("individuals[0]:",individuals[0].positionAssignments)
    }, [individuals]);

    useEffect(()=>{
        setCheckedValues([selectedIndividualId]);

    }, [selectedIndividualId]);

    const isChecked = (id: number|undefined) => checkedValues.some(item => item == id)
    const handleSelect = (event: ChangeEvent<HTMLInputElement>, individual: Partial<IIndividualLight>) => {
        if (event.target.checked && individual) {
            setCheckedValues([individual.individualId||0])
            onSelect(individual);
        }else {
            onSelect(undefined)
            setCheckedValues([]);
        };
    }

    return (
        <div style={{border:'1px solid gray',overflow: 'auto', maxHeight:'300px'}} >
            {loading && <SpinnerOverlay />}
                <Table striped className="organizations-table">
                    <thead>
                        <tr>
                            <th style={{width:'20px'}}>
                                <div className="hidden-text ">Select All</div>
                            </th>
                            <th>Individual Name</th>
                            <th>Email</th>
                            <th>Position/Role</th>
                        </tr>
                    </thead>

                    <tbody>
                    {
                        (!individuals || individuals.length===0) ? (
                            <tr><td></td><td></td><td  >No Individuals found.</td><td></td></tr>
                        ) :  (
                            individuals.map((indi:Partial<ISearchIndividualsForNewResult>,index: number) => (
                                <React.Fragment key={index}>
                                    {indi.assignments && indi.assignments.length===1 && (
                                        <tr key={index}>
                                            <td >
                                                <Input
                                                    type="checkbox"
                                                    aria-label={'Select individual ' + indi.fullName}
                                                    checked={isChecked(indi.individualId)}
                                                    onChange={(event) => handleSelect(event, indi)}
                                                />
                                            </td>
                                            <td >{indi.fullName}</td>
                                            <td >{indi.primaryEmail}</td>
                                            <td>
                                                {
                                                    indi.assignments[0].fullPositionName && (
                                                        <OmsToolTip positionId={indi.assignments[0].positionId}>
                                                                {indi.assignments[0].fullPositionName +' (' + (indi.assignments[0].relationshipType?indi.assignments[0].relationshipType:'Vacant') + ')'}
                                                        </OmsToolTip>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )}
                                    {indi.assignments && indi.assignments.length>1 && (
                                        <tr key={index}>
                                            <td rowSpan={indi.assignments.length}>
                                                <Input
                                                    type="checkbox"
                                                    aria-label={'Select individual ' + indi.fullName}
                                                    checked={isChecked(indi.individualId)}
                                                    onChange={(event) => handleSelect(event, indi)}
                                                />
                                            </td>
                                            <td rowSpan={indi.assignments.length}>{indi.fullName}</td>
                                            <td rowSpan={indi.assignments.length}>{indi.primaryEmail}</td>
                                            <td>
                                                {
                                                    indi.assignments[0].fullPositionName && (
                                                        <OmsToolTip positionId={indi.assignments[0].positionId}>
                                                                {indi.assignments[0].fullPositionName +' (' + (indi.assignments[0].relationshipType?indi.assignments[0].relationshipType:'Vacant') + ')'}
                                                        </OmsToolTip>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )}
                                    {indi.assignments && indi.assignments.length>1 && (
                                        indi.assignments.map((pos, posIndex) => (
                                            posIndex!==0 && (
                                            <tr key = {index*100+posIndex}>
                                                <td>
                                                    {
                                                        pos.fullPositionName && (
                                                            <OmsToolTip positionId={pos.positionId}>
                                                                    {pos.fullPositionName + ' (' + (pos.relationshipType?pos.relationshipType:'Vacant') + ')'}
                                                            </OmsToolTip>
                                                        )
                                                    }
                                                </td>
                                            </tr>)))
                                    )}
                                    {((!indi.assignments)||(indi.assignments.length<1)) && (
                                        <tr key={index}>
                                            <td>
                                                <Input
                                                    type="checkbox"
                                                    aria-label={'Select individual ' + indi.fullName}
                                                    checked={isChecked(indi.individualId)}
                                                    onChange={(event) => handleSelect(event, indi)}
                                                />
                                            </td>
                                            <td>{indi.fullName}</td>
                                            <td>{indi.primaryEmail}</td>
                                            <td></td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        )
                    }

                    </tbody>
                </Table>
        </div>
    )

}

export default IndividualList;
